import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full mb-[50px] h-full font-montserrat relative" }
const _hoisted_2 = { class: "relative w-full" }
const _hoisted_3 = { class: "p-[20px] relative bg-gray-50 min-h-screen top-[60px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-black font-bold py-[20px] md:py-[40px] text-center" }, "Home / User's liste", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "md:w-[calc(100%/3)]" }
const _hoisted_7 = { class: "text-left md:flex hidden w-full md:w-[calc(100%/3)] max-w-[400px]" }
const _hoisted_8 = { class: "md:w-[calc(100%/3)] flex justify-end" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-full pb-[10px] border-t border-gray-400 pt-[50px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '../components/headerComponentAdmin.vue'
import { ref, onMounted } from 'vue';
import axiosInstance from '@/plugins/axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'viewuser',
  setup(__props) {

const pageTitle = ref("User's liste")
const errorMessage = ref('')
let isSuperUser = ref(false);
let user = ref({});
const users = ref([]);

onMounted(() => {
  document.title = pageTitle.value;
});

const fetchUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const response = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    user.value = response.data;
    isSuperUser.value = response.data.is_staff;
  } catch (error) {
    console.error(error);
  }
};

const fetchAllUsers = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    let nextUrl = '/auth/users/';

    while (nextUrl) {
      const response = await axiosInstance.get(nextUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        users.value = [...users.value, ...response.data.results];
        nextUrl = response.data.next;
      } else {
        break; // Sortir de la boucle si la requête échoue
      }
    }
  } catch (error) {
    console.error('Erreur lors du chargement des utilisateurs', error);
  }
};

const activateUser = async (userId: any) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const userToActivate = users.value.find(user => user.id === userId);

    await axiosInstance.put(`/auth/users/${userId}/activate/`);

    window.location.reload();
    fetchAllUsers();
  } catch (error) {
    console.error('Erreur lors de l\'activation de l\'utilisateur', error);
  }
};

const deactivateUser = async (userId: any) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    const userToDeactivate = users.value.find(user => user.id === userId);

    await axiosInstance.put(`/auth/users/${userId}/desactivate/`);

    // Mettez à jour la liste des utilisateurs après la désactivation
    window.location.reload();
    fetchAllUsers();
  } catch (error) {
    console.error('Erreur lors de la désactivation de l\'utilisateur', error);
  }
};

onMounted(() => {
  fetchUserProfile();
  fetchAllUsers();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(headerComponent),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_unref(isSuperUser))
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: user.id,
                    class: "w-full p-[10px] min-h-[50px] border flex justify-between items-center"
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(user.firstname) + " " + _toDisplayString(user.lastname), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(user.email), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (user.is_active)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (deactivateUser(user.id)),
                            class: "bg-red-500 text-white p-[10px]"
                          }, "Désactiver", 8, _hoisted_9))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (activateUser(user.id)),
                            class: "bg-green-500 text-white p-[10px]"
                          }, "Activer", 8, _hoisted_10))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_11
  ], 64))
}
}

})